import "./AiOrb.css";
import useAiOrbAnimation from "./useAiOrbAnimation";

export default function AiOrb({
    label = "Ask AI",
    variant = "pill",
    onClick,
}) {

    const {
        orbRef,
        expanded,
        hovered,
        setHovered,
        style,
    } = useAiOrbAnimation();

    return (
        <button
            ref={orbRef}
            type="button"
            onClick={onClick}
            style={style}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`
                ai-orb
                ai-orb-${variant}
                ${expanded ? "ai-orb-expanded" : ""}
                ${hovered ? "ai-orb-hovered" : ""}
            `}
        >

            <div className="ai-orb-core">

                <span className="ai-orb-aurora"></span>

                <span className="ai-orb-glow"></span>

                <span className="ai-orb-gradient"></span>

                <span className="ai-orb-halo"></span>

                <span className="ai-orb-reflection"></span>

                <span className="ai-orb-center"></span>

            </div>

            <div className="ai-orb-shimmer"></div>

            <span className="ai-orb-label">
                {label}
            </span>

        </button>
    );
}